
import '~/js/views/general/golf/includes/stickyNav';
import '~/js/views/general/golf/includes/scroll-below';
import '~/js/modules/slider';

// Variable Declaration
const $tabSelects = $('#js-tab-select');
const $tabs = $('a[data-toggle="tab"]');

// Select handler
const selectHandler = (event, ui) => {
    const { index } = ui.item;

    $($tabs[index]).tab('show');
};

// Initialization selectmenu
$tabSelects.selectmenu({
    appendTo: $tabSelects.parent(),
    select: selectHandler
});

const slider = $('.js-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    prevArrow: '<span class="prev image-slider-arrow"><i class="ic ic-button-arrow-prev"></i></span>',
    nextArrow: '<span class="next image-slider-arrow"><i class="ic ic-button-arrow-next"></i></span>'
});

slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
    const nextImg = slick.$slides[nextSlide];
    const srcImg = nextImg.dataset.src;

    nextImg.src = srcImg;
    nextImg.addEventListener('load', () => {
        nextImg.style.opacity = 1;
    });
});
